export const sendMessageToParent = () => {
    if (window.top) {
        const height = document.body.offsetHeight;
        window.top.postMessage(`{ "iframe-height": ${height} }`, '*');
    }
};
